import {getPanasonicLog} from "../store/FlightStore";
import Const from "../constant/Const";

export const message = {
    IIS: "InFlight.js installed successfully.",
    EXS: "EXConnect sent",
    IFS: "InFlight sent",
    FDS: "FlightData sent",
    EXIS: "EXConnect installed successfully.",
    IFLS: "Failed to retrieve InFlight.js from panasonic system.",
    EXNF: "EXConnect not found.",
    FDTNF: "FlightData - TailNumber not found.",
    FDNF: "FlightData not found.",
    SUC: "Success",
    PSSV: "Panasonic services have been successfully verified.",
    GS500: "Ground system sent error. (checkUserStatusV2)"
};

export const service = {
    IS: "initService",
    IFJ: "inflightJs",
    EXV1: "exconnect/v1",
    GGCE: "getGlobalConnEnabled",
    GGCEL: "getGlobalConnEnabledListener",
    WISP: "getWISP",
    EDFWL: "enableDeviceForWhitelist",
    FDV2: "flightdata/v2",
    TAIL: "tailNumber",
    PS: "Panasonic",
    GS: "Ground"
};

const STORAGE_NAME = "pn-listener-log";

export default class PanasonicLogManager {

    constructor() {
    }

    res = (service, message) => {
        this.saveStorage(service, message, false, "RESPONSE");
    }

    req = (service, message) => {
        this.saveStorage(service, message, false, "REQUEST");
    }

    suc = (service, message) => {
        this.saveStorage(service, message, false, "SUCCESS");
    }

    err = (service, message) => {
        this.saveStorage(service, message, true, "ERROR");
    }

    listenerLog = () => {
        let logStorage = [];
        if (localStorage.getItem(STORAGE_NAME) !== null)
            logStorage = JSON.parse(localStorage.getItem(STORAGE_NAME));
        if (logStorage.length <= 10) {
            logStorage.push(new Date());
            localStorage.setItem(STORAGE_NAME, JSON.stringify(logStorage));
        }
    }

    listenerLogConnEnabled = () => {
        let logStorage = [];
        if (localStorage.getItem(STORAGE_NAME) !== null)
            logStorage = JSON.parse(localStorage.getItem(STORAGE_NAME));
        if (logStorage.length > 0) {
            this.saveStorage(service.GGCEL, "ERROR", true, "ERROR")
            localStorage.removeItem(STORAGE_NAME);
        }
    }

    saveStorage = (service, message, error, contentType) => {
        let logs = getPanasonicLog();
        let log = {
            localDate: new Date(),
            service: service,
            message: message,
            error: error,
            contentType: contentType
        };
        if (logs.length > 30)
            logs = logs.slice(1);
        logs.push(log);
        localStorage.setItem(Const.PANASONIC_LOG, JSON.stringify(logs));
    }
}


